import { http } from '@/lib/http';
import type { APIResponse } from '@/types';
import { LotteryEvent } from '../types';

export type GetLotteryEventParams = {
  oemServiceId: number;
  requestTime: string;
  getType: string;
  pagingLotteryEventId?: number;
  paging?: string;
  limit?: number;
  eventName?: string;
  artistId?: number;
  unitId?: number;
  lotteryPositionKey?: string;
  lotteryEventTagId?: number;
};

export type GetLotteryEventResponse = APIResponse<Array<LotteryEvent>>;

export const getLotteryEvent = async (params: GetLotteryEventParams) => {
  return await http<GetLotteryEventResponse>('/user/v1/lottery-event', {
    query: {
      oem_service_id: params.oemServiceId,
      request_time: params.requestTime,
      get_type: params.getType,
      paging_lottery_event_id: params.pagingLotteryEventId,
      paging: params.paging,
      limit: params.limit,
      event_name: params.eventName,
      artist_id: params.artistId,
      unit_id: params.unitId,
      lottery_position_key: params.lotteryPositionKey,
      lottery_event_tag_id: params.lotteryEventTagId,
    },
  });
};
